import PropTypes from 'prop-types';
import { Inline } from '@etg/wings';
import { css } from '@eti/styles';
import { CalendarBlank } from '@phosphor-icons/react';
import { IconWrapper } from './ItineraryComponents';

const durationInDaysStyles = css`
  text-align: center;
  width: 89px;
`;

const stayOverInfoWrapperStyles = css`
  width: 100%;
`;

const headingStyles = css`
  flex-grow: 1;
  margin-inline: 23px 16px;
`;

const ItineraryStayOverInfo = ({ calendarDate, durationInDays }) => (
  <Inline className={stayOverInfoWrapperStyles} spacing={0}>
    <div className={durationInDaysStyles} data-testid="tripDetails-stayOverInfo-durationInDays">
      {durationInDays && <p>{durationInDays}</p>}
    </div>
    <IconWrapper hasWhiteBackground>
      <CalendarBlank size={18} weight="light" />
    </IconWrapper>
    <p className={headingStyles} data-testid="tripDetails-stayOverInfo-date">
      {calendarDate}
    </p>
  </Inline>
);

ItineraryStayOverInfo.propTypes = {
  calendarDate: PropTypes.string,
  durationInDays: PropTypes.string,
};

export default ItineraryStayOverInfo;
